import React from 'react';
import RightRail from '../gs-component-right-rail';
import GdsProvider from './GdsClient';
import { ComponentStateProvider } from './ComponentStateContext';
import RightRailForm from './RightRailForm';
import ErrorToaster from './RightRailForm/errorToaster';
import { GuestModalProps as RightRailFormProps } from './interfaces';

type GuestModalProps = Omit<RightRailFormProps, 'showError' | 'clearError'>;

const GuestModal: React.FC<GuestModalProps> = props => {
  const { isOpen, overlay } = props;
  const [error, setError] = React.useState(false);

  const showError = (): void => setError(true);
  const clearError = (): void => setError(false);

  // force clear error if closed
  React.useEffect(() => {
    if (!isOpen) {
      clearError();
    }
  }, [isOpen]);

  return (
    <>
      <GdsProvider>
        <ComponentStateProvider>
          <RightRail open={isOpen} overlay={overlay}>
            {error && <ErrorToaster remove={clearError} />}

            <RightRailForm {...props} showError={showError} clearError={clearError} />
          </RightRail>
        </ComponentStateProvider>
      </GdsProvider>
    </>
  );
};

export default GuestModal;
